import { useState } from 'react';
import axios from 'axios';
import '../styles/CreateModule.css';
import '../styles/CreateSession.css';
import { Save } from 'lucide-react';

const CreateModuleModal = ({ onClose }) => {
    // course_name, number_of_hours, preceding_module, description
    const [formData, setFormData] = useState({
        course_name: '',
        academic_year: '',
        description: ''
    });

    // Function to handle form data changes
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async () => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/courses/createModule`, formData);
            if (response.status >= 200 && response.status < 300) {
                onClose();
            } else {
                console.error('Błąd podczas tworzenia modułu:', response.data);
            }
        } catch (err) {
            console.error('Błąd podczas tworzenia kursu:', err);
        }
    };

    return (
        <div className="module-modal-overlay">
            <div className="module-modal-content">
                <h3 className="modal-title">Utwórz nowy kurs</h3>

                <div className="form-group">
                    <label>Nazwa kursu *</label>
                    <input
                        name='course_name'
                        type='text'
                        className='form-input'
                        value={formData.course_name}
                        onChange={handleInputChange}
                    />
                </div>
                <div className="form-group">
                    <label>Rok akademicki *</label>
                    <input
                        name='academic_year'
                        type='text'
                        className='form-input'
                        value={formData.academic_year}
                        onChange={handleInputChange}
                        placeholder='np. 2025/2026'
                    />
                </div>
                <div className='form-group'>
                    <label>Opis (opcjonalne)</label>
                    <textarea
                        name='description'
                        value={formData.description}
                        onChange={handleInputChange}
                        placeholder='np. Ten kurs wprowadza ...'
                        className='form-input'
                    />
                </div>
                <div className="modal-actions">
                    <button onClick={onClose} className="button-secondary">Anuluj</button>
                    <button onClick={handleSubmit} className="button-primary">
                        <Save size={16} />
                        Zapisz
                    </button>
                </div>
            </div>
        </div>
    )
}

export default CreateModuleModal;
